export const indexPagesData: any = {
  'import-review-pies': {
    name: 'import-review-pies',
    headerColor: 'gold',
    title: 'Import Review',
    type: 'pies',
    editable: true,
    visible: true,
    itemStatuses: [4, 5],
    allow: ['admin', 'catalog-edit'],
  },
  'import-review-aces': {
    name: 'import-review-aces',
    headerColor: 'gold',
    title: 'Import Review',
    type: 'aces',
    editable: true,
    visible: true,
    itemStatuses: [4, 5],
    allow: ['admin', 'catalog-edit'],
  },
  'import-review-custom-fields': {
    name: 'import-review-custom-fields',
    headerColor: 'gold',
    title: 'Import Review',
    type: 'pies',
    editable: true,
    visible: true,
    itemStatuses: [4, 5],
    allow: ['admin', 'catalog-edit'],
  },
  'working': {
    name: 'working',
    headerColor: 'darkred',
    title: 'Working',
    editable: false,
    visible: true,
    itemStatuses: [0, 1, 2],
    allow: ['admin', 'catalog-edit'],
   },
  'published': {
    name: 'published',
    headerColor: 'cadetblue',
    title: 'Published',
    searchResultsTitle: 'Published Items',
    editable: false,
    visible: true,
    itemStatuses: [8, 10],
    allow: ['admin', 'catalog-edit', 'catalog-view', 'repository'],
  },
  'view-export': {
    name: 'view-export',
    headerColor: 'cornflowerBlue',
    title: 'View Export',
    searchResultsTitle: 'Items for Export',
    editable: true,
    visible: true,
    itemStatuses: [6],
    allow: ['admin', 'catalog-edit', 'repository'],
   }
};
